import produce from 'immer';
import { find, findIndex, get } from 'lodash';
import * as types from 'actions/details/types';

const initialState = {};

export default produce((draft, action) => {
  switch (action.type) {
    case types.FETCH:
      draft[action.payload.id] = { isLoading: true };
      break;
    case types.FETCH_SUCCESS: {
      const { id, data } = action.payload;

      draft[id] = { data, isLoading: false };
      break;
    }
    case types.FETCH_ERROR: {
      const { id, error } = action.payload;

      draft[id] = {
        isLoading: false,
        data: null,
        error: error.response.data,
      };
      break;
    }
    case types.FETCH_SEASONS:
      draft[action.payload.id].isLoading = true;
      break;
    case types.FETCH_SEASONS_SUCCESS: {
      const { id, data } = action.payload;

      draft[id].isLoading = false;
      draft[id].data.seasons = data.sort((a, b) => a.seasonNumber - b.seasonNumber);
      break;
    }
    case types.FETCH_EPISODES:
      draft[action.payload.contentId].isLoading = true;
      break;
    case types.FETCH_EPISODES_SUCCESS: {
      const { contentId, seasonIndex, data } = action.payload;

      draft[contentId].isLoading = false;
      draft[contentId].data.seasons[seasonIndex].episodes = data;
      break;
    }
    case types.FETCH_EPISODES_BATCH_SUCCESS: {
      const { contentId, content } = action.payload;

      const seasons = draft[contentId].data.seasons.map((season, i) => ({
        ...season,
        episodes: content[i],
      }));

      draft[contentId].isLoading = false;
      draft[contentId].data.seasons = seasons;

      break;
    }
    case types.FETCH_RELATED_ITEMS_SUCCESS: {
      const { data, contentId } = action.payload;

      draft[contentId].related = data;
      break;
    }
    case types.FETCH_EXTRA_RELATED_ITEMS: {
      const { contentId, listId } = action.payload;
      const index = findIndex(draft[contentId].related, { id: listId });

      draft[contentId].related[index].isOnLazyLoad = true;
      break;
    }
    case types.FETCH_EXTRA_RELATED_ITEMS_SUCCESS: {
      const { isAllItemsWereLoaded, contentId, listId, content, page } = action.payload;
      const index = findIndex(draft[contentId].related, { id: listId });

      draft[contentId].related[index].content = [
        ...draft[contentId].related[index].content,
        ...content,
      ];
      draft[contentId].related[index].isOnLazyLoad = false;
      draft[contentId].related[index].isAllItemsWereLoaded = isAllItemsWereLoaded;
      draft[contentId].related[index].page = page;
      break;
    }
    case types.FETCH_EXTRA_RELATED_ITEMS_ERROR: {
      const { contentId, listId, error } = action.payload;
      const index = findIndex(draft[contentId].related, { id: listId });

      draft[contentId].related[index].error = error;
      draft[contentId].related[index].isOnLazyLoad = false;
      break;
    }
    case types.FETCH_RECOMMENDATIONS_SUCCESS: {
      const { data, contentId } = action.payload;

      draft[contentId].recommendations = data;
      break;
    }
    case types.FETCH_EXTRA_RECOMMENDATIONS: {
      const { contentId } = action.payload;

      draft[contentId].recommendations.isOnLazyLoad = true;
      break;
    }
    case types.FETCH_EXTRA_RECOMMENDATIONS_SUCCESS: {
      const { isAllItemsWereLoaded, contentId, content, page } = action.payload;

      draft[contentId].recommendations.content = [
        ...draft[contentId].recommendations.content,
        ...content,
      ];
      draft[contentId].recommendations.isOnLazyLoad = false;
      draft[contentId].recommendations.isAllItemsWereLoaded = isAllItemsWereLoaded;
      draft[contentId].recommendations.page = page;
      break;
    }
    case types.FETCH_EXTRA_RECOMMENDATIONS_ERROR:
      draft[action.payload.contentId].recommendations.isOnLazyLoad = false;
      break;
    case types.TOGGLE_WATCHLIST_SUCCESS: {
      const { id, favorite } = action.payload;
      draft[id].data.favorite = favorite;
      break;
    }
    case types.SAVE_VIDEO_PROGRESS: {
      const { videoId, seriesId, episodeId, currentTime } = action.payload;

      if (seriesId) {
        const seasons = get(draft[seriesId], 'data.seasons');
        //Ищем сезон по episodeId
        const season = find(seasons, (season) =>
          find(get(season, 'episodes.content'), { id: episodeId }),
        );
        const episode = find(season.episodes.content, { id: episodeId });
        episode.bookmark = { seconds: currentTime };
      } else {
        if (draft[videoId]) {
          draft[videoId].data.bookmark = { seconds: currentTime };
        }
      }
      break;
    }
    case types.RESET_VIDEO_PROGRESS: {
      const { videoId, seriesId, episodeId } = action.payload;

      if (seriesId) {
        const seasons = get(draft[seriesId], 'data.seasons');
        //Ищем сезон по episodeId
        const season = find(seasons, (season) =>
          find(get(season, 'episodes.content'), { id: episodeId }),
        );
        const episode = find(season.episodes.content, { id: episodeId });
        episode.bookmark = { seconds: 0 };
      } else {
        draft[videoId].data.bookmark = { seconds: 0 };
      }
      break;
    }
    case types.UPDATE_DETAILS: {
      const { id, data } = action.payload;
      draft[id].data = data;
      break;
    }

    case types.BUY_DETAILS_ITEM: {
      const { assetId } = action.payload;

      draft[assetId].isOnPurchaseRequest = true;
      break;
    }
    case types.BUY_DETAILS_ITEM_SUCCESS:
    case types.BUY_DETAILS_ITEM_ERROR: {
      const { assetId } = action.payload;

      draft[assetId].isOnPurchaseRequest = false;
      break;
    }
    case types.RESET_ALL_DATA:
      return { ...initialState };
    default:
    // nothing
  }
}, initialState);
